import { faUserTie } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import { IEfilingMessage } from "../../../config/interfaces";
import { UtilService } from "../../../services";
import FASvgIcon from "../../FASvgIcon";

type Props = { message: IEfilingMessage };

const ExpertSideMessage: React.FC<Props> = (props: Props) => {
	const { message } = props;

	return (
		<div className={`chat-msg expert-msg`}>
			<div className="user-icon">
				<FASvgIcon icon={faUserTie} />
			</div>
			<div className="user-message">
				<h5 className="user-info">
					{message?.efilingMessageCreatedBy?.fullName || ""}
					<small>{UtilService.getTimeDisplay(message.createdAt)}</small>
				</h5>
				<div className="msg-content">
					<p>{message?.message?.text}</p>
				</div>
			</div>
		</div>
	);
};
export default ExpertSideMessage;
